import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Environment } from '@cp/shared/environment/environment.interface';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';

export interface ErrorModalData {
  title: string;
  errors: Array<string>;
}

@Component({
  selector: 'ui-universal-error-modal',
  templateUrl: './universal-error-modal.component.html',
  styleUrls: ['./universal-error-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversalErrorModalComponent {
  private _dialogRef = inject(MatDialogRef);
  private _environment = inject<Environment>(SHARED_ENVIRONMENT);

  public dashboardUrl = this._environment.globalDashboardUrl;

  public closeModal(event: Event): void {
    event.preventDefault();

    this._dialogRef.close();
  }
}
